import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import { useLocation, useNavigate } from "react-router-dom";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

export default function ListItemSq(open) {
  const history = useNavigate();
  const goReservation = (go) => {
    history(go);
  };
  return (
    <ListItem disablePadding sx={{ display: "block" }}>
      <ListItemButton
        sx={{
          minHeight: 48,
          justifyContent: open ? "initial" : "center",
          px: 2.5,
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: 0,
            mr: open ? 3 : "auto",
            justifyContent: "center",
          }}
        >
          <CalendarMonthIcon
            onClick={(e) => {
              goReservation("/sq/holdlist");
              e.stopPropagation();
            }}
          />
        </ListItemIcon>
        <ListItemText primary="보류목록" sx={{ opacity: open ? 1 : 0 }} />
      </ListItemButton>
      <Typography
        sx={{
          marginLeft: 1,
          color: "#000000",
          fontSize: "0.8rem",
        }}
        variant="h6"
      >
        {open.open === false ? "보류목록" : ""}
      </Typography>
    </ListItem>
  );
}
